import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import NumberAnimation from '@/components/numberAnimation/NumberAnimation.vue';
import Card from '@/components/layout/Card.vue';
import CardInteractive from '@/components/layout/CardInteractive.vue';
var SummaryItem = /*#__PURE__*/function (_Vue) {
  function SummaryItem() {
    var _this;
    _classCallCheck(this, SummaryItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SummaryItem, [].concat(args));
    _defineProperty(_this, "keyValue", void 0);
    _defineProperty(_this, "platform", void 0);
    _defineProperty(_this, "label", void 0);
    _defineProperty(_this, "zeroClass", void 0);
    _defineProperty(_this, "shortcutUrl", void 0);
    return _this;
  }
  _inherits(SummaryItem, _Vue);
  return _createClass(SummaryItem, [{
    key: "value",
    get: function get() {
      var summary = store.getters.summary(this.platform);
      if (summary === undefined) {
        return 0;
      }
      return store.getters.summary(this.platform)[this.keyValue];
    }
  }, {
    key: "zeroClassName",
    get: function get() {
      if (this.value === 0) {
        return this.zeroClass;
      } else {
        return '';
      }
    }
  }, {
    key: "openSummaryDetail",
    value: function openSummaryDetail(url, target) {
      window.open(url, target);
    }
  }]);
}(Vue);
__decorate([Prop()], SummaryItem.prototype, "keyValue", void 0);
__decorate([Prop()], SummaryItem.prototype, "platform", void 0);
__decorate([Prop({
  default: ''
})], SummaryItem.prototype, "label", void 0);
__decorate([Prop({
  default: ''
})], SummaryItem.prototype, "zeroClass", void 0);
__decorate([Prop({
  default: ''
})], SummaryItem.prototype, "shortcutUrl", void 0);
SummaryItem = __decorate([Options({
  components: {
    CardInteractive: CardInteractive,
    Card: Card,
    NumberAnimation: NumberAnimation
  }
})], SummaryItem);
export default SummaryItem;